import { AbsenceReason } from "../../../clients/graphqlTypes.js";

export const absenceColors: Record<AbsenceReason, string> = {
  VACATION: "#ff6e78",
  SICK_LEAVE: "#cd3560",
  TRAINING: "#921a52",
  OTHER: "#4c0a3e",
};
